<template>
  <div class="card-container">
    <ul class="card">
      <CardItem
        v-for="(item, key) in items.values"
        :key="key"
        :id="item"
        :name="regions[item].name"
        :desc="regions[item].desc"
        :like="items.like == item"
        :dislike="items.dislike == item"
      />
    </ul>

    <div class="actions">
      <button @click="prevStep" class="prev">← Zurück</button>
      <button @click="nextStep" class="next" :disabled="!completed">Weiter →</button>
    </div>
  </div>
</template>

<script>
import CardItem from '@/components/CardItem'

export default {
  name: 'Card',
  components: {
    CardItem,
  },
  props: ['items'],
  computed: {
    activeStep() {
      return this.$store.state.activeStep
    },
    regions() {
      return this.$store.state.regions
    },
    completed() {
      if (this.items.dislike && this.items.like) return true
      return false
    },
  },
  methods: {
    prevStep() {
      this.$store.dispatch('handlePrevClick')
    },
    nextStep() {
      this.$store.dispatch('handleNextClick')
    },
  },
}
</script>

<style scoped>
.card {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 30px -5px -5px -5px;
}
</style>
